import {i18n} from '../i18n';

export default {
    name: 'LanguageSwitcher',
    data: () => ({
        languages: [
            {
                flag: 'gb', language: 'en', title: 'English'
            },
            {
                flag: 'fr', language: 'fr', title: 'Français'
            },
            {
                flag: 'de', language: 'de', title: 'Deutsch'
            }
        ]
    }),
    template: '<div class="text-center">' +
        '<button v-for="lang in languages" :key="lang.title" ' +
        '@click="changeLang(lang.language)" class="btn-lang btn-light mt-4 mr-1 ml-1">' +
        '<flag :iso="lang.flag" v-bind:squared=false /> {{lang.title}}' +
        '</button>' +
        '</div>',
    methods: {
        changeLang(lang) {
            i18n.locale = lang;
        }
    },
}